import { Component } from '@theme/component';

/**
 * Reveals each step (and the connecting progress line) as the section
 * scrolls into view. Runs once per page load; respects
 * prefers-reduced-motion by skipping straight to the revealed state.
 *
 * @extends {Component}
 */
export class ProcessStepsComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !window.IntersectionObserver) {
      this.#reveal();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.#reveal();
            this.observer.disconnect();
          }
        }
      },
      { threshold: 0.3 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  #reveal() {
    this.setAttribute('revealed', '');
  }
}

if (!customElements.get('process-steps-component')) {
  customElements.define('process-steps-component', ProcessStepsComponent);
}
